import { Link, useParams } from "react-router-dom"

import Nav from 'react-bootstrap/Nav'
import { userPermissionsSummarySignal } from '../../../state/signals/permissionSignals.js'

export default function AdministrationTabs({ activeKey }) {

    const { beId } = useParams()

    return (
        <Nav variant="tabs" size="sm" activeKey={activeKey} className="px-3 my-3">
            {userPermissionsSummarySignal.value.canViewAccounts && <Nav.Item>
                <Link className={"nav-link".concat(activeKey == "1" ? " active" : "")} eventkey="1" to={`/be/${beId}/management/accounts`}>Business Entities</Link>
            </Nav.Item>}
            {userPermissionsSummarySignal.value.canViewGroups && <Nav.Item>
                <Link className={"nav-link".concat(activeKey == "2" ? " active" : "")} eventkey="2" to={`/be/${beId}/management/groups`}>Groups</Link>
            </Nav.Item>}
            {userPermissionsSummarySignal.value.canViewRoles && <Nav.Item>
                <Link className={"nav-link".concat(activeKey == "3" ? " active" : "")} eventkey="3" to={`/be/${beId}/management/roles`}>Roles</Link>
            </Nav.Item>}
            {userPermissionsSummarySignal.value.canViewUsers && <Nav.Item>
                <Link className={"nav-link".concat(activeKey == "4" ? " active" : "")} eventkey="4" to={`/be/${beId}/management/users`}>Users</Link>
            </Nav.Item>}
            {/* userPermissionsSummarySignal.value.canViewSystemUsers && <Nav.Item>
                <Link className={"nav-link".concat(activeKey == "5" ? " active" : "")} eventkey="5" to={`/be/${beId}/management/systemUsers/serviceUsers`}>System Users</Link>
            </Nav.Item> */}
        </Nav>
    )
}